import React, { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
//@ts-ignore
import LKModal, { LKModalContainer, actions as LKModalActions } from 'shared/LKModal'
//@ts-ignore
import ClientSearch, { getTitle } from 'shared/ClientSearch'
import { translate } from 'loankeeper-common/helpers'
import { delegateClientSearchModal, delegateClientSearch, addDelegateModalName } from '../../../constants'
import { linkedFile } from '../../../types'

const clientSearchGridConfig = {
  syncGridState: true,
  enableRowSelection: true,
  enableColumnsHide: true,
  enableColumnsOrder: true,
  enableColumnsResize: true,
  enableSorting: true,
}

const searchPanelConfig = {
  initialValues: {
    categ: {
      individuals: true,
      solidarityGroups: false,
      companies: false,
    },
  },

  fieldsDisability: {
    categ: {
      individuals: false,
      solidarityGroups: true,
      companies: true,
    },
    safety: {
      insured: false,
      watched: false,
      blacklisted: false,
    },
  },
}

const onChoose = (closeClientSearchModal, openDelegateAddModal, data, linkedfiles) => {
  if (data.ClientType === 1) {
    closeClientSearchModal()
    openDelegateAddModal(false, data, linkedfiles)
  }
}

const getGetContextMenuItems =
  (closeClientSearchModal, openDelegateAddModal, linkedfiles) =>
  ({
    node: {
      data,
      data: { Full_Name },
    },
  }) =>
    [
      {
        name: Full_Name,
        disabled: true,
      },
      {
        name: translate('frm_client_list-cmd_select'),
        action: () => onChoose(closeClientSearchModal, openDelegateAddModal, data, linkedfiles),
        icon: 'hand',
      },
    ]

const getOnRowDoubleClicked =
  (closeClientSearchModal, openAddRelationModal, linkedfiles) =>
  ({ node: { data } }) => {
    onChoose(closeClientSearchModal, openAddRelationModal, data, linkedfiles)
  }

const ClientSearchModal: FC<{
  modalInstanceName: string
  closeModal: () => void
  linkedfiles: linkedFile[]
}> = ({ modalInstanceName, closeModal, linkedfiles }) => {
  const dispatch = useDispatch()

  const title: string = useSelector((state) => getTitle(state, { instanceName: delegateClientSearch }))

  const handleOpenDelegateAddModel = React.useCallback(
    (isEdit, client, linkedfiles) => {
      dispatch(LKModalActions.open({ name: addDelegateModalName, isEdit, client, linkedfiles }))
    },
    [dispatch],
  )

  const gridConfig = React.useMemo(
    () => ({
      ...clientSearchGridConfig,
      onRowDoubleClicked: getOnRowDoubleClicked(closeModal, handleOpenDelegateAddModel, linkedfiles),
      getContextMenuItems: getGetContextMenuItems(closeModal, handleOpenDelegateAddModel, linkedfiles),
    }),
    [handleOpenDelegateAddModel, closeModal, linkedfiles],
  )

  return (
    <LKModal name={modalInstanceName} heading={title} size="lg">
      <ClientSearch instanceName={delegateClientSearch} gridConfig={gridConfig} searchPanelConfig={searchPanelConfig} />
    </LKModal>
  )
}

export default LKModalContainer(delegateClientSearchModal)(ClientSearchModal)
